import React from 'react'
import {connect} from 'react-redux'
import NavBarItem from "../components/NavBarItem"
import {tooltips} from "../constants"
import {StyledLi, StyledInput} from '../styled-components/components'
import {selectPreset, setPresetName} from "../actions/index"

const PresetSelector = ({name, preset, presetName, dispatch}) => {
    var options = []
    console.log("preset selector", preset)
    for(var x = 1; x<= 28; x++){
        options.push(<option key={x}> {x} </option>)
    }

    return (
        <>
        <StyledLi tooltip={tooltips.Panic} name={name} onChange = {(e)=> dispatch(selectPreset(e.target.value))} className="presetSelector" >
            {name}
            <select>
                {options}
            </select>

        </StyledLi>
        <StyledLi tooltip={tooltips.Panic} name={name} className="presetTitle" >
            <StyledInput maxlength="5" placeholder="Preset Title..." type="text" value={presetName} onChange={(e)=>dispatch(setPresetName(preset, e.target.value))}  /> 

        </StyledLi>
        </>
    )
}

function mapStateToProps(state){
    console.log("preset state",state)
    var presetName = state.presetSettings.present.getIn([state.preset,"name"])
    presetName = presetName == undefined ? "" : presetName
    return{
        preset : state.preset,
        presetName : presetName
    }
}

export default connect(mapStateToProps)(PresetSelector)